<template>
  <div>
    <b-container class="container--max-750 text-center mt-6">
      <h1 class="h3 mb-4">{{ $t("lang.label_certificate_step3") }}</h1>
    </b-container>
    <b-form @submit.prevent="onSubmit" novalidate :validated="wasValidated">
      <b-container class="container--max-810 mt-5">
        <b-card>
          <form-group-certificate v-model="certificate"></form-group-certificate>

          <div class="text-right mt-2">
            <b-button name="sendRequest" type="submit" size="lg" variant="primary"> {{ $t("lang.label_certificate_apply") }}</b-button>
          </div>
          <div>{{ $t("lang.label_star_explained") }}</div>
        </b-card>
      </b-container>
    </b-form>
  </div>
</template>
<script>
import FormGroupCertificate from "../../components/certificate/FormGroupCertificate";
import CertificateKeyPairMode from "../../api/enums/CertificateKeyPairMode";
import CertificateValidity from "../../api/enums/CertificateValidity";
import * as utils from "@/utils";

export default {
  name: "CreateCertificateFromExisting",
  props: {
    id: {
      required: true
    }
  },
  data() {
    return {
      /* Certificate */
      certificate: {
        country: "",
        commonName: "",
        org: "",
        orgUnit: "",
        email: "",
        domainName: "",
        validFor: CertificateValidity.THREE_MONTHS,
        certUsageType: null,
        certPublicKeyAlgorithm: null,
        certSignatureAlgorithm: null,
        pkcs10ReqBase64: null,
        certCryptoType: null,
        keyPairMode: CertificateKeyPairMode.SERVERGEN
      },
      wasValidated: false
    };
  },
  methods: {
    onSubmit(evt) {
      if (evt.target.checkValidity() === false) {
        this.wasValidated = true;
        return;
      }
      this.createCertificate();
    },
    async createCertificate() {
      try {
        const response = await this.$store.dispatch("certificate/createCertificate", this.certificate);
        const certGenResponse = response.data;
        await this.$router.push({
          name: "certificate-keypair-download",
          params: {
            id: certGenResponse.certificate.id,
            keypairFile: certGenResponse.base64EncodedPkcs12,
            keypairPassword: certGenResponse.pkcs12Password,
            keypairFilename: certGenResponse.fileName
          }
        });
      } catch (ex) {
        await this.$store.dispatch("alert/showFailureAlert", this.$t("lang.message_certificate_create_error"));
      }
    }
  },
  mounted() {
    this.$store
      .dispatch("certificate/getCertificate", { certId: this.id })
      .then(response => {
        const existingCertificate = response.data;
        if (existingCertificate) {
          // Populate the certificate form's fields from the selected existing certificate
          const subjectDn = utils.parseSubjectDnString(existingCertificate.subjectDn);
          const overrideFields = {
            country: subjectDn.C,
            commonName: subjectDn.CN,
            org: subjectDn.O,
            orgUnit: subjectDn.OU,
            email: existingCertificate.email,
            domainName: existingCertificate.domainName,
            certUsageType: existingCertificate.certUsageType,
            certPublicKeyAlgorithm: existingCertificate.certPublicKeyAlgorithm,
            certSignatureAlgorithm: existingCertificate.certSignatureAlgorithm,
            certCryptoType: existingCertificate.certCryptoType
          };
          this.certificate = Object.assign({}, this.certificate, overrideFields);
        }
      })
      .catch(() => {
        this.$store.dispatch("alert/showFailureAlert", this.$t("lang.message_certificate_load_error"));
      });
  },
  components: { FormGroupCertificate }
};
</script>
